import { ChangeDetectionStrategy, Component, inject, Input, OnDestroy, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Guid } from 'guid-typescript';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { MatMenuItem } from '@angular/material/menu';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

import { LocalStorage } from '~/v2/core/helpers/localStorage';
import { AuthenticationService } from '~/app/auth/authentication.service';
import { ACTIVEMEMBER_STORAGE_KEY, MemberIdentity } from '@v2/core/security/models/memberidentity';
import { BrainnetPrincipal } from '@v2/core/security/models/brainnetprincipal';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-user-identity',
  templateUrl: './user-identity.component.html',
  styleUrls: ['./user-identity.component.scss'],
  imports: [MatMenuItem, NgClass, MatIcon],
})
export class UserIdentityComponent implements OnInit, OnDestroy {
  @Input() identity!: MemberIdentity;

  subscriptions: Subscription = new Subscription();
  isActiveMember = signal(false);

  private readonly homePage = '/supplier/home';

  private readonly auth = inject(AuthenticationService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    const sub = this.auth.principal$.pipe(filter((p): p is BrainnetPrincipal => !!p)).subscribe((principal) => {
      const isActiveMember = principal.activeMember.identifier.equals(this.identity.identifier);
      this.isActiveMember.set(isActiveMember);
    });

    this.subscriptions.add(sub);
  }

  switchMember(identifier: Guid): void {
    const sub = this.auth.boabaasUser$.pipe(take(1)).subscribe((user) => {
      if (user.identities.some((member) => member.identifier.toString() === identifier.toString())) {
        LocalStorage.setGuid(ACTIVEMEMBER_STORAGE_KEY, identifier);
      }

      this.router.navigate([this.homePage]).then(() => window.location.reload());
    });

    this.subscriptions.add(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
